// ACTIONS
export const FETCH = 'offerzen/topSkills/FETCH'
export const FETCH_SUCCESS = 'offerzen/topSkills/FETCH_SUCCESS'
export const FETCH_ERROR = 'offerzen/topSkills/FETCH_ERROR'

export const SEARCH = 'offerzen/topSkills/SEARCH'
export const SEARCH_SUCCESS = 'offerzen/topSkills/SEARCH_SUCCESS'
export const SEARCH_ERROR = 'offerzen/topSkills/SEARCH_ERROR'

export const UPDATE = 'offerzen/topSkills/UPDATE'
export const UPDATE_SUCCESS = 'offerzen/topSkills/UPDATE_SUCCESS'
export const UPDATE_ERROR = 'offerzen/topSkills/UPDATE_ERROR'

export const TOGGLE = 'offerzen/topSkills/TOGGLE'

// ACTION CREATORS
export const fetchTopSkills = id => ({
  type: FETCH,
  payload: {
    loading: true,
    id,
  },
})

export const fetchTopSkillsSuccess = data => ({
  type: FETCH_SUCCESS,
  payload: {
    loading: false,
    data,
  },
})

export const fetchTopSkillsError = errorMessage => ({
  type: FETCH_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

export const searchTopSkills = text => ({
  type: SEARCH,
  payload: {
    searching: true,
    text,
  },
})

export const searchTopSkillsSuccess = data => ({
  type: SEARCH_SUCCESS,
  payload: {
    searching: false,
    data,
  },
})

export const searchTopSkillsError = errorMessage => ({
  type: SEARCH_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

export const updateTopSkills = (id, data, resolve, reject) => ({
  type: UPDATE,
  meta: { resolve, reject },
  payload: {
    loading: true,
    id,
    data,
  },
})

export const updateTopSkillsSuccess = data => ({
  type: UPDATE_SUCCESS,
  payload: {
    loading: false,
    data,
  },
})

export const updateTopSkillsError = errorMessage => ({
  type: UPDATE_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

export const toggle = editing => ({
  type: TOGGLE,
  payload: { editing },
})

const initialState = {
  editing: false,
  loading: false,
  searching: false,
  error: null,
  list: [],
  searchResults: [],
}

// REDUCERS
const topSkillsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH:
    case UPDATE:
      return {
        ...state,
        loading: payload.loading,
      }

    case SEARCH:
      return {
        ...state,
        searching: payload.searching,
      }

    case FETCH_SUCCESS:
    case UPDATE_SUCCESS:
      return {
        ...state,
        loading: payload.loading,
        list: payload.data,
      }

    case SEARCH_SUCCESS:
      return {
        ...state,
        searching: payload.searching,
        searchResults: payload.data,
      }

    case FETCH_ERROR:
    case UPDATE_ERROR:
    case SEARCH_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      }

    case TOGGLE:
      return {
        ...state,
        editing: payload.editing,
      }

    default:
      return state
  }
}

export default topSkillsReducer

export const getTopSkills = state => state.views.profile.topSkills || initialState
